module.exports = __webpack_public_path__ + "static/media/Logo.62d1f13a.svg";